import React from 'react';
import { CameraIcon } from 'lucide-react';
import { profile } from '../../data/profil';
const fieldClass = 'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-[15px] text-ville-navy placeholder:text-slate-400 transition-colors duration-150 ease-ville focus:border-ville-indigo focus:outline-none focus:ring-2 focus:ring-ville-indigo/20';
const labelClass = 'block text-sm font-semibold text-slate-600';
interface FieldProps {
  id: string;
  label: string;
  type?: string;
  defaultValue?: string;
  placeholder?: string;
}
function Field({
  id,
  label,
  type = 'text',
  defaultValue,
  placeholder
}: FieldProps) {
  return <div data-id="element-1791" data-mp="3baoiki0mu21d">
      <label htmlFor={id} className={labelClass} data-id="element-1792" data-mp="3bd0vggrj9m7k">
        {label}
      </label>
      <input id={id} type={type} defaultValue={defaultValue} placeholder={placeholder} className={`mt-1.5 ${fieldClass}`} data-id="element-1793" data-mp="3g8g9p9tgdk4i" />
    </div>;
}
export function PersonalInfo() {
  return <section aria-labelledby="personal-info-title" className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8" data-id="element-1794" data-mp="24vxb1vh07iyd">
      <h2 id="personal-info-title" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1795" data-mp="1bfto258p861z">
        Personal information
      </h2>

      <div className="mt-6 flex flex-wrap items-center gap-5" data-id="element-1796" data-mp="1kfylbmk6ho2f">
        <span className="grid h-20 w-20 place-items-center rounded-full bg-ville-indigo-soft text-xl font-bold text-ville-indigo" aria-hidden="true" data-id="element-1797" data-mp="1kh9obk5sursh">
          {profile.initials}
        </span>
        <div data-id="element-1798" data-mp="1ucl5080rq92v">
          <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1799" data-mp="1uc1lwnzdten9">
            <CameraIcon className="h-4 w-4" aria-hidden="true" data-id="element-1800" data-mp="2d4ndux764l2k" />
            Change my photo
          </button>
          <p className="mt-2 text-xs text-slate-500" data-id="element-1801" data-mp="285swlzoun4kk">JPG or PNG, 5 MB maximum.</p>
        </div>
      </div>

      <form className="mt-8 grid gap-5 sm:grid-cols-2" onSubmit={event => event.preventDefault()} data-id="element-1802" data-mp="15so9z01y15dt">
        <Field id="prenom" label="First name" defaultValue={profile.firstName} data-id="element-1803" data-mp="19t88a6y96f1j" />
        <Field id="nom" label="Last name" defaultValue={profile.lastName} data-id="element-1804" data-mp="1est3q7e7s59i" />
        <Field id="naissance" label="Date of birth" type="date" defaultValue={profile.birthDate} data-id="element-1805" data-mp="1eqq8n8y7flxx" />
        <Field id="courriel" label="Email" type="email" defaultValue={profile.email} data-id="element-1806" data-mp="1jlmcr7gptzre" />
        <Field id="tel" label="Primary phone" type="tel" defaultValue={profile.phone} data-id="element-1807" data-mp="1oicqvp8ymla6" />
        <Field id="tel-secondaire" label="Secondary phone" type="tel" placeholder="Optional" defaultValue={profile.phoneSecondary} data-id="element-1808" data-mp="1tg5ucaivp16r" />
        <Field id="cellulaire" label="Mobile phone" type="tel" defaultValue={profile.mobile} data-id="element-1809" data-mp="1xhhqkyw9cknx" />
      </form>
    </section>;
}